import { render, staticRenderFns } from "./FieldsView.vue?vue&type=template&id=6b6afe6c&lang=pug"
import script from "./FieldsView.vue?vue&type=script&lang=js"
export * from "./FieldsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports